import { gql } from '@apollo/client';

export const getProvidedUserInformation = gql`
  query GetProvidedUserInformation {
    getProvidedUserInformation {
      value {
        creditStudyId
        userId
        academicBackground
        declaredIncome
        maritalStatus
        declaresRent
        hasDependents
        dateOfBirth
        employmentSituation
        employerName
        incomingSource
        contractType
      }
    }
  }
`;
